import { AppDispatch } from '../store';
import { loginSuccess, loginFailure, logout, refreshSuccess, userInfoSuccess, roleConfigSuccess } from '../reducers/authReducer';
import { userAccountAjax } from '../../ajax/UserAccountAjax';
import { settingsAjax } from '../../ajax/SettingsAjax';
import { isSuccessfulLoginResponse } from '../../types/Auth/SuccessfulLoginResponse';
import { isRefreshResponse } from "../../types/Auth/RefreshResponse";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { isOnlineNow } from "../../offline/connectivity";
import { resetCachedQueriesIfUserChanged } from "../../offline/resetCachedQueriesIfUserChanged";

export const loginUser = (email: string, password: string) => async (dispatch: AppDispatch) => {
  try {
    const response = await userAccountAjax.login(email, password);

    if (isSuccessfulLoginResponse(response)) {
      await resetCachedQueriesIfUserChanged(email);
      dispatch(loginSuccess(response));

      const userDetails = await userAccountAjax.getMyInfo();
      if (!userDetails || userDetails instanceof ErrorResponse) {
        dispatch(loginFailure('Failed to retrieve user details.'));
        return false;
      }
      dispatch(userInfoSuccess(userDetails));

      const roleConfig = await settingsAjax.getRoleConfig();
      if (!roleConfig || roleConfig instanceof ErrorResponse) {
        dispatch(loginFailure('Failed to retrieve role configuration.'));
        return false;
      }
      dispatch(roleConfigSuccess(roleConfig));

      return true;
    } else {
      dispatch(loginFailure('Login failed. Please check your credentials and try again.'));
      return false;
    }
  } catch {
    dispatch(loginFailure('Login failed. Please try again.'));
    return false;
  }
};

export const logoutUser = () => async (dispatch: AppDispatch) => {
  dispatch(logout())
};

export const refreshToken = (refreshToken: string) => async (dispatch: AppDispatch) => {
  if (!isOnlineNow()) return null;

  try {
    const response = await userAccountAjax.refreshToken(refreshToken);
    if (isRefreshResponse(response)) {
      dispatch(refreshSuccess(response));
      return response;
    }

    const rejectedByServer = Array.isArray(response?.errors)
      && response.errors.some(e => e.code === 400 || e.code === 401 || e.code === 403);

    if (rejectedByServer) {
      console.error('Refresh token rejected by the server; signing out', response);
      dispatch(logout());
    } else {
      console.error('Token refresh failed without a rejection; keeping the session', response);
    }
    return null;
  } catch {
    return null;
  }
}